import { useEffect, useState } from 'react'

export const useSlickReady = (hasData = true) => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (!hasData) return

    const id = requestAnimationFrame(() => {
      setReady(true)
    })
    return () => cancelAnimationFrame(id)
  }, [hasData])

  return ready
}
